import React, { useState } from "react";
import { Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { whatsappNumber, whatsappMessage } from "../../data/siteData";
import "./Header.css";

function Header() {
  const [open, setOpen] = useState(false);

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  const links = [
    { label: "Início", href: "#inicio" },
    { label: "Benefícios", href: "#beneficios" },
    { label: "Produtos", href: "#produtos" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header className="site-header">
      <div className="site-header__container">
        <a href="#inicio" className="site-header__logo">
          <img src="/logo/logoo.png" alt="Sweet Foods" />
        </a>

        <nav className="site-header__nav">
          {links.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <a href={whatsappLink} className="site-header__cta" target="_blank" rel="noreferrer">
          Falar no WhatsApp
        </a>

        <button className="site-header__menu" onClick={() => setOpen(true)}>
          <MenuOutlined />
        </button>
      </div>

      <Drawer open={open} onClose={() => setOpen(false)} placement="right">
        <div className="site-header__drawer">
          {links.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}

          <a href={whatsappLink} target="_blank" rel="noreferrer" className="btn-whatsapp">
            Falar no WhatsApp
          </a>
        </div>
      </Drawer>
    </header>
  );
}

export default Header;